var React = require('react');

function BlackAquarius (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":".4776 9.0373 5.6134 3.9015 9.8924 8.1815 14.1732 3.9015 18.4532 8.1815 22.7331 3.9015 27.8688 9.0373 25.4483 11.4587 22.7331 8.7435 18.4532 13.3172 14.1732 9.0345 9.8933 13.3172 5.6134 8.7435 2.8991 11.4587 .4776 9.0373","fill":"#ebc192","strokeWidth":"0","key":0}),React.createElement("polygon",{"points":".4776 20.165 5.6134 15.0293 9.8924 19.3092 14.1732 15.0293 18.4532 19.3092 22.7331 15.0293 27.8688 20.165 25.4483 22.5864 22.7331 19.8713 18.4532 24.4449 14.1732 20.1623 9.8933 24.4449 5.6134 19.8713 2.8991 22.5864 .4776 20.165","fill":"#ebc192","strokeWidth":"0","key":1})]);
}

BlackAquarius.defaultProps = {"id":"Layer_1","data-name":"Layer 1","version":"1.1","viewBox":"0 0 28.3465 28.3465"};

module.exports = BlackAquarius;

BlackAquarius.default = BlackAquarius;
